import React, { useContext, useState } from "react";
import {
  Box,
  Typography,
  Container,
  Grid, // <-- Импорт Grid для разметки
  List, // <-- Для списка слева
  ListItemButton, // <-- Кликабельные пункты списка
  ListItemText,
  Paper, // <-- "Бумажный" фон для контента
  Avatar,
  Divider, // <-- Разделительная линия
} from "@mui/material";
import { LangContext } from "../../LanguageProvider";
import parse from "html-react-parser";

const cardData = [
  {
    id: 2,
    name: "Маратова Аида Маратовна",
    title_ru: "Директор Республиканского Высшего технического колледжа",
    title_kz: "Республикалық жоғары техникалық колледжінің директоры",
    info: `<table>
    <thead>
<tr>
      <th>Номер</th>
      <th>Наградалар атауы</th>
      <th>Уақыты</th>
      </tr
    </thead>
    <tbody>
<tr>
      <td>1</td>
      <td>«Батыс-Желтоқсан» қоғамдық бірлестігінің төрағасы К.Максутованың Алғыс хат</td>
      <td>16.02.2024 ж.</td>
</tr> <tr>
      <td>2</td>
      <td>Кәсіподақ төрағасы А.Мұқашаева «Білім және ғылым қызметкерлерінің кәсіподағына сіңірген еңбегі үшін» төсбелгі	Куәлік №2460</td>
      <td>29.10.2023</td>
</tr> <tr>
      <td>3</td>
      <td>«AMANAT» партиясы Батыс Қазақстан облыстық филиалының Атқарушы атшысы А.Сафималиевтың Алғыс хат	2023ж.</td>
      <td>2023</td>
      </tr> <tr>
      <td>4</td>
      <td>Казақстан Республикасының Президентін сайлау науқанына дайындық және оны өткізу жұмыстарына қосқан үлесі үшін, Қазақстан Республикасы президенті Қасым-Жомарт Тоқаетың Алғыс хаты	Қараша</td>
      <td>2022</td>
      </tr>





5		Отаншылдық ұстанымыңыз және жалпыұлттық референдумды ұйымдастыруға, өткізуге белсене қатысқаны үшін, Қазақстан Республикасы президенті Қасым-Жомарт Тоқаетың Алғыс хаты	Маусым, 2022ж.
6		Батыс Қазақстан облысының әкімі Н.Төреғалиевтың Алғыс хат	2022ж.
7		Қазақстан Республикасы Парламентінің Мәжілісі мен мәслихаттар депутаттар сайлауында белсенділік көрсеткені үшін Нұрсұлтан Назарбаевтың Алғыс хаты	2021ж.
8		«Nur Otan» партиясы Батыс Қазақстан облыстық филиалының төрағасы Ғ.Есқалиевтың Алғыс хат	2020ж.
9		Қазақстан Республикасы Президентінің сайлауы аясында жүргізілген үгіт-насихат жұмыстарына белсенді қатысқаны үшін Қазақстан Республикасы президенті Қасым-Жомарт Тоқаетың Алғыс хаты	2019ж.
10	«Қазақстан Республикасының Тәуелсіздігіне 25 жыл» мерекелік медалі	29 қараша, 2016ж.
11	Қазақстан Республикасы Парламенті Мәжілісі мен мәслихаттары депуттарының сайлауында «Нұр Отан» партиясының сайлау науқанына белсене қатысқаны үшін «Нұр Отан» партиясының Төрағасы Н.Назарбаевтың Алғыс хаты	Наурыз, 2016ж.
12	Орал қалалық Қоғамдық кеңесінің мүшесі Орал қалалық мәслихаттың хатшысы А.Аубекеров	№13 куәлік, 01.03.2019ж.
13	Орал қалалық мәслихатының депутаты
Орал қалалық сайлау комиссиясының төрағасы Н.Бекқайыр	№8 куәлік             7 шақырылған 2021-2026жж.
</tbody>
</table>

`,
    email: "maratova_@mail.ru",
    phone: "8(7112)50-34-20, 8-775-666-75-39",
    image: "/Director2.jpeg",
  },
  {
    id: 3,
    name: "Аубакирова Клара Мураткалиевна",
    title_ru: "Заместитель директора по учебной работе",
    title_kz: "Оқу жұмысы жөніндегі директордің орынбасары",
    email: "",
    phone: "",
    image: "",
  },
  {
    id: 4,
    name: "Кенжегалиев Азамат Максутович",
    title_ru: "Заместитель директора по учебно-производственной работе",
    title_kz: "Оқу-тәжірибе жұмысы жөніндегі директордің орынбасары",
    email: "",
    phone: "",
    image: "/photo/admin/Azamat.jpeg",
  },
  {
    id: 5,
    name: "Отарбаева Жанат Омиржановна",
    title_ru:
      "Заведующий отделом IT - технологий, нефти, газа, экономики и права",
    title_kz:
      "IT - технологиялар, мұнай, газ, экономика және құқық бөлімінің орынбасары",
    email: "",
    phone: "",
    image: "/photo/admin/Zhanat.jpeg",
  },
  {
    id: 6,
    name: "Айтмұханбетова Анара Талапқызы",
    title_ru: "Заведующий отделом транспорта и телекоммуникаций",
    title_kz: "Транспорт және телекоммуникациялар бөлімінің орынбасары",
    email: "",
    phone: "",
    image: "/photo/admin/Anara.jpeg",
  },
  {
    id: 7,
    name: "Габдешова Мансия Наримановна",
    title_ru: "Заместитель директора по учебно-воспитательной работе",
    title_kz: "Оқу және тәртіп жұмысы жөніндегі директордің орынбасары",
    email: "",
    phone: "",
    image: "/photo/admin/Mansia.jpeg",
  },
  {
    id: 8,
    name: "Ситказиева Амина Жусуповна",
    title_ru: "Менеджер отдела кадров",
    title_kz: "Кадры бөлімінің менеджері",
    email: "",
    phone: "",
    image: "/photo/admin/Amina.jpeg",
  },
];
const tableStyles = {
  "& table": {
    width: "100%",
    borderCollapse: "collapse",
    border: "1px solid",
    borderColor: "divider", // Цвет из темы (светло-серый/темно-серый)
    mt: 2,
  },
  "& th, & td": {
    border: "1px solid",
    borderColor: "divider",
    padding: "8px 12px",
    textAlign: "left",
  },
  "& th": {
    backgroundColor: "action.hover", // Легкий фон из темы
    fontWeight: "bold",
  },
  "& tr:nth-of-type(even)": {
    backgroundColor: "action.focusOpacity", // Легкая "зебра"
  },
};

function AdminPage() {
  const { translations, lang } = useContext(LangContext);

  // 1. Добавляем состояние (State) для хранения ВЫБРАННОГО сотрудника.
  // По умолчанию показываем первого в списке (директора).
  const [selectedPerson, setSelectedPerson] = useState(cardData[0]);

  // Функция для обновления состояния при клике в списке
  const handleSelectPerson = person => {
    setSelectedPerson(person);
  };
  return (
    <Box
      sx={{
        // Используем цвета из темы, а не #f5f5f5
        backgroundColor: "background.default",
        minHeight: "100vh",
        paddingTop: "50px",
        marginTop: "100px",
      }}>
      <Container maxWidth="lg">
        {/* ЗАГОЛОВОК СТРАНИЦЫ */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          style={{
            fontWeight: "bold",
            color: "text.primary", // Используем цвет текста из темы
            marginBottom: "40px",
          }}>
          {translations["administration"]}
        </Typography>

        {/* НОВЫЙ МАКЕТ: СЕТКА (Grid) */}
        <Grid container spacing={3}>
          {" "}
          {/* spacing={3} - отступ между колонками */}
          {/* КОЛОНКА 1: СПИСОК (4/12 ширины на десктопе, 12/12 на мобильных) */}
          <Grid item xs={12} md={4}>
            <Paper elevation={3} sx={{ overflow: "auto" }}>
              <List component="nav" sx={{ p: 0 }}>
                {cardData.map(person => (
                  <ListItemButton
                    key={person.id}
                    // Выделяем пункт, если ID в state совпадает с ID этого пункта
                    selected={selectedPerson && selectedPerson.id === person.id}
                    // При клике - обновляем state
                    onClick={() => handleSelectPerson(person)}>
                    <ListItemText
                      primary={person.name}
                      secondary={
                        lang == "ru" ? person.title_ru : person.title_kz
                      } // Должность показываем сразу
                    />
                  </ListItemButton>
                ))}
              </List>
            </Paper>
          </Grid>
          {/* КОЛОНКА 2: ДЕТАЛИ (8/12 ширины на десктопе, 12/12 на мобильных) */}
          <Grid item xs={12} md={8}>
            {/* Показываем контент, только если кто-то выбран */}
            {selectedPerson && (
              <Paper elevation={3} sx={{ p: 3 }}>
                <Avatar
                  src={selectedPerson.image}
                  alt={selectedPerson.name}
                  variant="rounded" // Прямоугольный аватар
                  sx={{
                    // Растягиваем фото
                    width: "100%",
                    height: "450px",
                    mb: 3,
                    objectFit: "contain",
                    borderRadius: 2,
                  }}
                />
                <Typography
                  variant="h4"
                  component="h2"
                  gutterBottom
                  sx={{ fontWeight: "bold" }}>
                  {selectedPerson.name}
                </Typography>

                <Typography variant="h6" color="primary.main" gutterBottom>
                  {lang == "ru"
                    ? selectedPerson.title_ru
                    : selectedPerson.title_kz}
                </Typography>

                <Typography variant="body1" sx={{ mt: 2 }}>
                  <strong>Почта:</strong> {selectedPerson.email || "Нет данных"}
                </Typography>

                <Typography variant="body1">
                  <strong>Контактный телефон:</strong>{" "}
                  {selectedPerson.phone || "Нет данных"}
                </Typography>

                <Divider sx={{ my: 3 }} />

                {/* Здесь выводим доп. инфо БЕЗ аккордиона */}
                {selectedPerson.info ? (
                  <Box sx={tableStyles}>
                    {" "}
                    {/* Применяем стили к таблице */}
                    {parse(selectedPerson.info)}
                  </Box>
                ) : (
                  <Typography>Нет дополнительной информации</Typography>
                )}
              </Paper>
            )}
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default AdminPage;
